import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
	limit: JSON.parse(localStorage.getItem('pageLimit') as string) || 10,
	data: null,
	pages: 1,
	page: 1,
	firedListSettings: JSON.parse(
		localStorage.getItem('selectedFiredListTabs') as string
	) || [
			'name',
			'login',
			'role',
			'position',
			'project',
			'areas',
			'vsv',
			'freelancer',
			'firedData',
			'firedreason',
			'comment',
			'whoFired',
			'phone',
			'verified'
		],
	isPending: true,
	filters: {
	}
};

export const firedEmployeesListSlice = createSlice({
	name: 'firedEmployeesList',
	initialState,
	reducers: {
		reducerFiredEmployeesListSettings: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			state.firedListSettings = action.payload;
		},
		
		reducerVacancyMultiselect: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			state.vacancyListInputValues = { ...state.vacancyListInputValues, ...action.payload };
		},
	},
});

export const {
	reducerFiredEmployeesListSettings,
	reducerVacancyMultiselect,
} = firedEmployeesListSlice.actions;

export default firedEmployeesListSlice.reducer;
